// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__117pP","index":"styles_index__2VFWx"};